module.exports = __webpack_public_path__ + "img/porteB_unlock.375ced53.svg";